
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber } from '@/utils/common'

@Component

export default class ComponentBackofficeProcedimentoConfiguracaoOperadora extends Vue {
  @Prop({ default: false }) disabled: boolean

  $refs!: { formProcedimentoDeInternacao: any }

  formProcInternacao: any = {
    valid: true,
    procedimento: [v => !!v || 'Escolha um procedimento para internação.'],
    procedimentoDeInternacaoASerAutorizadoQuantidade: [v => v > 0 || 'Informe a quantidade.'],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get procedimentoInternacaoOperadora() {
    return this.getBackofficeGlobalStore.procedimentoInternacaoOperadora
  }

  get temProcedimentoDeInternacaoASerAutorizado() {
    const { hospitalEConvenioUtilizamRoboDeAutorizacao, convenioEnviaProcedimentoInternacao, procedimentosInternacaoOperadora } = this.getBackofficeGlobalStore.solicitacao
    if (!convenioEnviaProcedimentoInternacao || !hospitalEConvenioUtilizamRoboDeAutorizacao) return false
    if (procedimentosInternacaoOperadora) return procedimentosInternacaoOperadora.length > 0
    return false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }
}
